// extracted by mini-css-extract-plugin
export default {"aggregateTable":"show_aggregateTable__8WDtk"};